import { StartAvatarRequest } from "@heygen/streaming-avatar";
import { StreamingAvatarStore } from "@/features/avatar/store/StreamingAvatarStore";
import { useCallback } from "react";
import { StreamingAvatarSessionState } from "@/features/avatar/const";

interface UseAvatarProps {
    avatarStore: StreamingAvatarStore;
    config: StartAvatarRequest;
}

export const useAvatar = ({ avatarStore, config }: UseAvatarProps) => {
    async function createSessionToken() {
        try {
            const response = await fetch(
                "https://api.heygen.com/v1/streaming.create_token",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key":
                            "YjFjYjU0MWExNDY0NDU5MmI5NDI3NmQ0NjQxNjY4NTAtMTczOTYzMzk5MQ==",
                    },
                },
            );
            const { data } = await response.json();
            console.log("Access Token:", data);
            return data.token; // Log the token to verify
        } catch (error) {
            console.error("Error fetching access token:", error);
            throw error;
        }
    }

    const startSessionV2 = useCallback(
        async (isVoiceChat: boolean) => {
            try {
                const newToken = await createSessionToken();
                console.log("avatarStore", avatarStore.avatarStream);
                if (!avatarStore.avatarStream) {
                    avatarStore.init(newToken);
                    await avatarStore.start(config);
                }
                if (
                    avatarStore.avatarStream &&
                    avatarStore.sessionState ===
                        StreamingAvatarSessionState.INACTIVE
                ) {
                    await avatarStore.start(config);
                }

                // if (isVoiceChat) {
                //     await startVoiceChat();
                // }
            } catch (error) {
                console.error("Error starting avatar session:", error);
            }
        },
        [avatarStore, config],
    );

    return { startSessionV2 };
};
